<template>
  <div class="system-builder__configure-system--section" sticky-container>
    <div class="system-builder__system-container">
      <div v-sticky sticky-offset="offset" sticky-side="top">
        <img src="/live/wp-content/themes/compustar/images/module-family.png" alt="Compustar systems family">
      </div>
    </div>

    <div class="system-builder__configure-system-container">

      <div class="system-builder__main-container--header">
        <h2>Build Your System</h2>
      </div>

      <div class="system-builder__main-container--content">
        <div class="system-builder__configure-system--vehicle-container">
          <h3>1) Enter Your Vehicle</h3>
          <p>What is your vehicle's year, make and model?</p>

          <transition name="fade">
            <div v-if="sharedState.vehicleMakesData.length < 1">
              <spinner size="large" message="Loading Vehicle list..."></spinner>
            </div>

            <div v-else>
              <div class="select-button-style">
                <div class="arrow-button"></div>
                <select ref="makesSelection" id="vehicle-make" name="vehicle-make" v-model="sharedState.selectedMake" @change="getVehicleModels">
                  <option :value="sharedState.selectedMake" selected disabled>{{sharedState.selectedMake}}</option>
                  <option disabled>_____________</option>
                  <option v-for="make in sharedState.vehicleMakesData" v-bind:value="make">{{ make }}</option>
                </select>
              </div>

              <div class="select-button-style">
                <div class="arrow-button"></div>
                <select id="vehicle-model" name="vehicle-model" v-model="sharedState.selectedModel" @change="getVehicleYears">
                  <option :value="sharedState.selectedModel" selected disabled>{{sharedState.selectedModel}}</option>
                  <option disabled>_____________</option>
                  <option v-for="model in sharedState.vehicleModelsData" v-bind:value="model">{{ model }}</option>
                </select>
              </div>

              <div class="select-button-style">
                <div class="arrow-button"></div>
                <select id="vehicle-year" name="vehicle-year" v-bind:data-id="sharedState.selectedYear" v-model="sharedState.selectedYear" @change="updateVehicleObjectState">
                  <option :value="sharedState.selectedYear" :data-year="sharedState.selectedYearValue" selected disabled>{{sharedState.vehicleObject.year}}</option>
                  <option disabled>_____________</option>
                  <option v-for="item in sharedState.vehicleYearsData" v-bind:value="item.id">{{ item.year }}</option>
                </select>
              </div>
            </div>
          </transition>
        </div>

        <div class="system-builder__configure-system--system-container">
          <h3>2) Choose Your System</h3>
          <a @click="categoryModal=true">Which system is right for you?</a>
          <div id="remoteStart" class="system-builder__configure-system--system-option" :class="{'system-builder__configure-system--system-option-selected': sharedState.remoteStart}" @click="setSelectedCategory">
            I want to remote start my car.
          </div>
          <div id="security" class="system-builder__configure-system--system-option" :class="{'system-builder__configure-system--system-option-selected': sharedState.security}" @click="setSelectedCategory">
            I want to secure my car.
          </div>
          <div id="remoteStartSecurity" class="system-builder__configure-system--system-option" :class="{'system-builder__configure-system--system-option-selected': sharedState.remoteStartSecurity}" @click="setSelectedCategory">
            I want to remote start & secure my car.
          </div>
        </div>

        <div class="system-builder__configure-system--upgrade-container">
          <h3>3) Optional System Upgrades</h3>
          <a @click="upgradeModal=true">Which upgrades are right for you?</a>
          <div class="system-builder__configure-system--upgrade-option" v-for="currentOption in options" :id="currentOption.id" :selected="currentOption.selected" :locked="currentOption.locked" @click="updateSelectedAttribute" :key="currentOption.id" v-bind:class="{ 'system-builder__configure-system--upgrade-option-selected': checkIfAttributeSelected(currentOption.id)}">
            {{currentOption.name}}

            <notification name="lockedMessage" nColor="rgba(226, 144, 37, 0.85)" v-if="currentOption.locked" :isActive="lockedMessage" @closeNotification="lockedMessage=false">
              <div slot="notification-body">
                {{currentOption.lockedMessage}}
              </div>
            </notification>
          </div>
        </div>
      </div>

    </div>
    <footerNav></footerNav>
    <modal name="categoryInfoModal" :isActive="categoryModal" @closeModal="categoryModal=false">
      <div slot="modal-body">

      </div>
    </modal>

    <modal name="upgradeInfoModal" :isActive="upgradeModal" @closeModal="upgradeModal=false">
      <div slot="modal-body">
        <div class="system-builder__modal--item" v-for="upgrade in sharedState.accessories">
          <div class="system-builder__modal--item-image">
            <img :src="upgrade.images[0].image.url" :alt="upgrade.images[0].image.alt">
          </div>

          <div class="system-builder__modal--item-content">
            <h4>{{upgrade.post_title}}</h4>
            <div v-html="upgrade.description"></div>
          </div>
        </div>
      </div>
    </modal>

    <notification name="successNotification" nColor="#78bf5e" :isActive="successNotification" @closeNotification="successNotification=false">
      <div slot="notification-body">
        Your vehicle is compatible!
      </div>
    </notification>

    <notification name="warningNotification" nColor="#d25b4b" :isActive="warningNotification" @closeNotification="warningNotification=false">
      <div slot="notification-body">
        Please check with a dealer near you for vehicle compatibility.
      </div>
    </notification>
  </div>
</template>

<script>
import store from '../../store/index'
import axios from 'axios'
import modal from '../reusable/modal.vue'
import notification from '../reusable/notification.vue'
import footerNav from '../reusable/stickyFooterNavigation.vue'
import spinner from 'vue-simple-spinner'

export default {
  components: { footerNav, modal, spinner, notification },
  name: 'configureSystem',
  data () {
    return {
      sharedState: store.state,
      options: store.state.selectableOptions,
      categoryModal: false,
      upgradeModal: false,
      successNotification: false,
      warningNotification: false,
      lockedMessage: false,
      offset: {
        top: 75
      }
    }
  },
  methods: {
    updateVehicleObjectState: function (event) {
      this.vehicleId = event.target.value

      store.updateVehicleObject(this.sharedState.selectedMake, this.sharedState.selectedModel, event.target.value)
      store.updateCurrentStepValidation(true)

      // Display message depending on vehicle compatibility
      if (this.sharedState.vehicleObject.compatibleSystem === false) {
        this.successNotification = false
        this.warningNotification = true
      } else if (this.sharedState.vehicleObject.compatibleSystem === null || this.sharedState.vehicleObject.compatibleSystem === '') {
        this.warningNotification = false
        this.successNotification = true
      }
    },
    cleanArray: function (arr) {
      return arr.filter(function (x, i) {
        return arr.indexOf(x) === i
      })
    },
    separateYearArray: function (originalArray) {
      var automaticYears = []
      var manualYears = []
      var value

      for (var i = 0; i < originalArray.length; i++) {
        value = originalArray[i]['trany']

        if (value === 'Automatic') {
          automaticYears.push(originalArray[i])
        } else {
          manualYears.push(originalArray[i])
        }
      }

      // Send manual transmission array state
      store.updateManualYears(manualYears)

      return automaticYears
    },
    getVehicleMakes: function () {
      var makesArr = []
      var vehicleMakes = this.sharedState.vehicleJson.makes[0]

      for (var i in vehicleMakes) {
        makesArr.push(i)
      }

      // Clean make array
      makesArr = this.cleanArray(makesArr)
      makesArr = makesArr.sort()

      return makesArr
    },
    getVehicleModels: function (event) {
      var makeValue = event.target.value
      var vehicleMakes = this.sharedState.vehicleJson.makes[0]
      var modelArray = []

      for (var i in vehicleMakes) {
        if (i === makeValue) {
          var vehicleMake = vehicleMakes[i]
          for (var x in vehicleMake) {
            modelArray.push(vehicleMakes[i][x]['model'])
          }
        }
      }

      // Strip model array of duplicate values and sort
      modelArray = this.cleanArray(modelArray)
      modelArray = modelArray.sort()

      this.sharedState.vehicleModelsData = modelArray
    },
    getVehicleYears: function (event) {
      var makeValue = this.sharedState.selectedMake
      var modelValue = event.target.value
      var yearArray = []
      var vehicleMakes = this.sharedState.vehicleJson.makes[0]

      for (var i in vehicleMakes) {
        if (i === makeValue) {
          var vehicleMake = vehicleMakes[i]
          for (var x in vehicleMake) {
            if (vehicleMakes[i][x]['model'] === modelValue) {
              yearArray.push({
                year: vehicleMakes[i][x]['year'],
                id: vehicleMakes[i][x]['id'],
                trany: vehicleMakes[i][x]['trany'],
                compatibleSystem: vehicleMakes[i][x]['compatibleSystem'],
                vehicleSpecificId: vehicleMakes[i][x]['vehicleSpecificId']
              })
            }
          }
        }
      }

      // Clean duplicate year values
      yearArray = this.separateYearArray(yearArray)
      yearArray = yearArray.sort(function (a, b) {
        return b.year - a.year
      })

      this.sharedState.vehicleYearsData = yearArray
    },
    setSelectedCategory: function (event) {
      store.setCategorySelectionState(event.target.id)
    },
    updateSelectedAttribute: function (event) {
      if (event.target.attributes.length > 0) {
        var optionId = event.target.attributes['id'].value
        var isLocked = this.sharedState.selectableOptions[optionId].locked

        if (isLocked === false) {
          store.setSelectedAttribute(event.target.id)
        } else {
          this.lockedMessage = true
        }
      }
    },
    checkIfAttributeSelected: function (optionId) {
      // check sharedState to see if current attribute is selected
      return this.sharedState.selectableOptions[optionId].selected
    },
    getVehicleData: function () {
      var host = 'https://' + window.location.hostname

      var themePath = '/wp-content/themes/compustar/javascript/'
      var jsonPath = host + themePath + 'vehicles.json'

      axios.get(jsonPath).then((response) => {
        store.holdVehicleJson(response.data)
        this.sharedState.vehicleJson = response.data
        this.sharedState.vehicleMakesData = this.getVehicleMakes()
      }).catch(error => {
        console.log(error)
      })
    }
  },
  created: function () {
    if (this.sharedState.vehicleJson === null) {
      this.getVehicleData()
    }
    store.getLocalStorage()
  }
}
</script>



// WEBPACK FOOTER //
// ConfigureSystem.vue?6a514506